.app {
  width: 100%;
}

.salesSteeringList {
  width: 100%;

  td,
  th {
    padding: 0.5rem;
  }
}

.container {
  display: flex;
  justify-content: center;
}

.searchBox {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.attentionRow {
  background-color: #ffeaf2; // light pink
}
